import { ModalDialog } from '@infinitro/global';

const MODAL_VALUES = Object.values(ModalDialog) as string[];

export const match = (param: string) => {
	return MODAL_VALUES.includes(param);
};
